import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import { toWidget, toWidgetEditable, viewToModelPositionOutsideModelElement } from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

import InsertHSButtonCommand from './insertHsButtonCommand';

export default class HSButtonEditing extends Plugin {
    static get requires() {
        return [ Widget ];
    }

    init() {
        this._defineSchema();
        this._defineConverters();

        this.editor.commands.add( 'insertHSButton', new InsertHSButtonCommand( this.editor ) );

        this.editor.editing.mapper.on(
            'viewToModelPosition',
            viewToModelPositionOutsideModelElement( this.editor.model, viewElement => viewElement.hasClass( 'hs-button' ) )
        );
		}

    _defineSchema() {
        const schema = this.editor.model.schema;

        schema.register( 'hsButton', {
            // Behaves like a self-contained object (e.g. an image).
            isObject: true,
						isContent: true,

            // Allow in places where other blocks are allowed (e.g. directly in the root).
            allowWhere: '$block'
        } );
    }

		_defineConverters() {
        const conversion = this.editor.conversion;

        // <hsButton> converters
        conversion.for( 'upcast' ).elementToElement( {
            model: 'hsButton',
            view: {
                name: 'section',
                classes: 'hs-button'
            }
        } );
        conversion.for( 'dataDowncast' ).elementToElement( {
            model: 'hsButton',
            view: {
                name: 'section',
                classes: 'hs-button'
            }
        } );
        conversion.for( 'editingDowncast' ).elementToElement( {
            model: 'hsButton',
            view: ( modelElement, { writer: viewWriter } ) => {
                const section = viewWriter.createContainerElement( 'section', { class: 'hs-button' } );
								const hsButtonOptions = this.editor.config.get("hsButtonOptions");

								viewWriter.insert(
									viewWriter.createPositionAt(section, 0),
									viewWriter.createText(hsButtonOptions.buttonText)
								);

                return toWidget( section, viewWriter); //, { label: 'hs button widget' } );
            }
        } );
    }
}